import { requiredPhoneListValidator } from '@utils/validators';

const handleErrors = values => {
  return {
    phoneNumber: requiredPhoneListValidator(values.phoneNumber),
  };
};
export default handleErrors;
